import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
import { buyers } from '../data/content';
const FIRST_DELAY = 6000;
const SHOW_FOR = 5000;
const GAP = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timer: number;
    const cycle = (i: number) => {
      setIndex(i);
      setShow(true);
      timer = window.setTimeout(() => {
        setShow(false);
        timer = window.setTimeout(() => cycle((i + 1) % buyers.length), GAP);
      }, SHOW_FOR);
    };
    timer = window.setTimeout(() => cycle(Math.floor(Math.random() * buyers.length)), FIRST_DELAY);
    return () => window.clearTimeout(timer);
  }, [dismissed]);
  const buyer = buyers[index];
  const initials = buyer.name.split(' ').map(p => p[0]).join('');
  return <div className="pointer-events-none fixed bottom-[92px] left-3 z-50 w-[calc(100%-1.5rem)] max-w-[340px] sm:bottom-24 sm:left-5" data-id="element-43" data-mp="164oa074zg5up">
      <AnimatePresence data-id="element-44" data-mp="1151xy10w4vnh">
        {show && !dismissed && <motion.div key={index} role="status" initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 8,
        scale: 0.98
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-[0_12px_32px_rgba(6,18,41,0.28)] ring-1 ring-navy-900/10" data-id="element-45" data-mp="1fuhaabzocyjn">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-navy-900 text-sm font-black text-cta" data-id="element-46" data-mp="s56hphshaagl">
              {initials}
            </span>
            <div className="min-w-0" data-id="element-47" data-mp="23lwfqdmqzvz4">
              <p className="text-sm font-extrabold leading-tight text-ink" data-id="element-48" data-mp="23kv3w6xwr5gc">
                {buyer.name} from {buyer.country}
              </p>
              <p className="mt-0.5 text-xs leading-snug text-muted" data-id="element-49" data-mp="2fnnzj54wb1xi">
                just purchased the <span className="font-bold text-ink" data-id="element-50" data-mp="2fphagwmjk8bb">Critical Care Nursing Blueprint™</span>
              </p>
              <p className="mt-1 flex items-center gap-1 text-[11px] font-bold text-success" data-id="element-51" data-mp="2pltypezbhtyo">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-52" data-mp="1ry3hqpkhaapt" />
                Verified purchase · {buyer.minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-muted transition-colors duration-150 hover:bg-paper hover:text-ink" aria-label="Dismiss notification" data-id="element-53" data-mp="1wxg130c54znn">
              <XIcon className="h-4 w-4" data-id="element-54" data-mp="197c0l1u91g0v" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}